import React, { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import moment from "moment";
import { connect } from "react-redux";
import { findItem } from "Components/forms/select-input";
import FilterElement from "Components/FilterElement";
import PrimaryButton from "Components/Button/PrimaryButton";
import Button from "Components/Button/Button";
import TriangleDown from "Components/icons/TriangleDown/TriangleDown";
import TriangleUp from "Components/icons/TriangleUp/TriangleUp";
import * as types from "Utils/alertKeys";
import { normalizeDateFilters } from "Utils/reports/reportFilterUtils";
import { validateFiltersAgainstValidationRule } from "Utils/validationUtils";
import "./CustomQueueFilterPane.scss";
import SingleListSelector from "Components/SingleListSelector";
import DashedButton from "Components/Button/DashedButton";
import OutsideClickHandler from "Components/OutsideClickHandler";
import { sortColumnsByInt } from "Utils/dualListSelectorUtils";
import ResponseBanner from "Components/cards/ResponseBanner";
import RemoveIcon from "../icons/RemoveIcon";
import InformationBubble from "Components/information-bubble/InformationBubble";
import ImagePortal from "Containers/ImagePortal";
import CustomQueueSorting from "../../components/CustomQueueSorting";
import {
  getSortFiltersParamToCustomQueuePage,
  getSortOrderToCustomQueuePage,
} from "Apis/searchFilterApi";
import { isEmpty, each } from 'Utils/lodashUtils';

class CustomQueueFilterPane extends Component {
  constructor(props) {
    super(props);
    this.scrollFilterClose = this.scrollFilterClose.bind(this);

    const showMoreFilters = false; // always start by only showing first 8 filters
    const showMoreExclusionFilters = false;
    const normalizedValues = normalizeDateFilters(
      props.filterList,
      props.currentValues,
      props.dateFormat,
      this.props.showDynamicFilter
    );
    const currentValuesObj = normalizedValues.reduce((obj, value) => {
      return Object.assign(obj, {
        [value.id]: {
          v1: value.v1,
          v2: value.v2,
          type: value.type,
          error: value.error,
          flag: value.flag,
        },
      });
    }, {});

    this.state = {
      selectedCardType: null,
      currentValues: currentValuesObj,
      filtersCount: this.props.filterList.length,
      selectedItem: this.props.filterList[0],
      showMoreFilters,
      showMoreExclusionFilters,
      sortedFilterList: this.getCurrentlyShownFilters(
        props.filterList,
        showMoreFilters
      ),
      sortedFilterErrors: {},
      sortedExclusionFilterList: this.getExclusionShownFilters(
        props.exclusionFilterList,
        showMoreExclusionFilters
      ),
      visibleCount: props.filterList.length,
      exclusionVisibleCount: props.activeExclusionFilters.length,
      isSingleListSelectorOpen: false,
      isSecSortListSelectorOpen: false,
      isSortFilterAvailable: true,
      isExclusionListSelectorOpen: false,
      currentActiveColumns: [],
      availableFilters: this.props.availableFilters,
      availableExclusionFilters: this.props.availableExclusionFilters,
      isExpanded: false,
      visible: false,
      currentSearchTerm: "",
      selectedReasonCode: [],
      selectedCorpRegionCode: [],
      selectedActionCode: [],
      selectedActivityCode: [],
      selectedDispCategory: [],
      selectedDisputeCurr: [],
      selectedMccCode: [],
      selectedTransactionCurr: [],
      selectedSettlementCurr: [],
      visibility: false,
      corp: [],
      region: [],
      corpRegion: [],
      scheduleButton: false,
      clearScheuldeFilters: true,
      existingScheduleFilters: [],
      merchant_hierarchy: props.merchant_hierarchy,
      isCancelWarning: false,
      sortFilterList: [],
      isCreate: false,
      createUpdateButtonDisabled: false,
      isClearAll: false,
      filterValuesState: [],
      readOnly: false,
    };
    this.attachBindings();
  }

  componentDidUpdate(prevProps, prevState) {
    const isErrorExist = !isEmpty(this.state.sortedFilterErrors);
    if (prevState.currentValues !== this.state.currentValues || (isErrorExist && prevState.createUpdateButtonDisabled !== this.state.createUpdateButtonDisabled)) {
      const currentValueObj = this.state.currentValues;
      if (
        currentValueObj?.cq_name?.v1 &&
        currentValueObj?.cq_base_queue?.v1.length > 0 &&
        currentValueObj?.cq_label?.v1 &&
        currentValueObj?.cq_assigned_to?.v1 &&
        !isErrorExist
      ) {
        this.setState((prevState) => ({
          createUpdateButtonDisabled: false,
        }));
      } else
        this.setState((prevState) => ({
          createUpdateButtonDisabled: true,
        }));
    }
  }

  mapToCurrentValue = () => {
    let newdata = {};
    this.props.updateValues.forEach((item) => {
      newdata[item.updatedId] = {
        v1: item.v1,
        v2: item?.v2,
        flag: item.flag,
      };
    });
    return newdata;
  };

  componentDidMount() {
    const initialCurrentValue = {
      ...this.mapToCurrentValue(),
    };

    getSortFiltersParamToCustomQueuePage().then((response) => {
      if (response.status.statusCode === 2000) {
        this.setState({
          filterValuesState: response.data,
        });
      }
    });

    getSortOrderToCustomQueuePage().then((response) => {
      if (response.status.statusCode === 2000) {
        this.setState({
          filterValuesSortState: response.data,
        });
      }
    });

    this.setState({
      currentValues: initialCurrentValue,
    });
    window.addEventListener("scroll", this.scrollFilterClose);
  }

  trueFalseLogic = (current, update) => {
    let fact = [];
    if (
      update?.elementType == "DYNAMIC_MULTISELECT" ||
      update?.elementType == "GROUP_SEARCH"
    ) {
      current?.v1.forEach((v) => {
        fact.push(update?.v1.includes(v));
      });
      update?.v1.forEach((v) => {
        fact.push(current?.v1.includes(v));
      });
      return !fact.includes(false);
    } else {
      return current?.v1 == update?.v1;
    }
  };

  createButtonDisabledLogic = () => {
    let currentValues = this.state.currentValues;
    let activeFilterValues = this.props.activeFilters.filter(
      (element) => element.elementMandatory
    );
    let activeSortValues = this.props.activeSortFilters.filter(
      (element) => element.elementMandatory
    );
    let mandatoryValues = [...activeFilterValues, ...activeSortValues];
    let state = [];

    mandatoryValues.forEach((mandatoryItem) => {
      if (currentValues[mandatoryItem.elementId]?.v1?.length > 0) {
        state.push("true");
      } else {
        state.push("false");
      }
    });
    if (state.includes("false")) {
      return true;
    }

    // FROM-TO value validations
    let toFromFieldsState = [];
    this.state?.duplicateSortedFilterList
      ?.filter(
        (item) =>
          item?.elementCategoryName == "FROM-TO" &&
          item?.elementTypeName == "CURRENCYRANGE"
      )
      .forEach((item) => {
        let element = currentValues[item.elementId];
        if (!(element?.v1?.length > 0 || element?.v2?.length > 0)) {
          // v1 and v1 empty then update btn enabled
          return false;
        } else {
          if (element?.v1?.length > 0 && element?.v2?.length > 0) {
            toFromFieldsState.push("true");
          } else {
            toFromFieldsState.push("false");
          }
        }
      });
    if (toFromFieldsState.includes("false")) {
      return true;
    }

    // default conditon ( switch not used because  "elementCategoryName" and "elementTypeName" need to check)
    return false;
  };

  updateButtonDisabledLogic = (nextProps) => {
    let currentValues = this.state.currentValues;
    let updateValues = {};
    // DYNAMIC_MULTISELECT values to taken fromqueryData because API called original data was mutating on local changes data is ',' sapareted string here it converted in array
    nextProps.updateValues.forEach((item) => {
      if (item.elementType == "DYNAMIC_MULTISELECT" && item.queryData) {
        let t1 = item.queryData.indexOf("(");
        let t2 = item.queryData.indexOf(")");
        let newV1 = item.queryData
          .slice(t1 + 1, t2)
          .split(",")
          .map((iv) => {
            return iv.replace(/'/g, "");
          });
        updateValues[item.updatedId] = {
          v1: newV1,
          v2: item?.v2,
          elementType: item.elementType,
        };
      } // GROUP_SEARCH values are also added into local updateValues
      else if (item.elementType == "GROUP_SEARCH") {
        updateValues[item.updatedId] = {
          v1: item?.v1,
          v2: item?.v2,
          elementType: item.elementType,
        };
      } else {
        updateValues[item.updatedId] = {
          v1: item.v1,
          v2: item?.v2,
        };
      }
    });

    let state = [];
    Object.keys(updateValues).forEach((ckey) => {
      Object.keys(currentValues).forEach((ukey) => {
        let diabledCond =
          (currentValues[ckey]?.v1 != null &&
            currentValues[ckey]?.v1?.length == 0) ||
          (this.trueFalseLogic(currentValues[ckey], updateValues[ckey]) &&
            currentValues[ckey]?.v2 == updateValues[ckey]?.v2 &&
            Object.keys(currentValues).includes(ckey));
        state.push({ disabled: diabledCond });
      });
    });

    // this code will detect new added filed
    Object.keys(currentValues).forEach((ckey) => {
      Object.keys(updateValues).forEach((ukey) => {
        let disabledCond =
          (currentValues[ckey]?.v1 != null &&
            currentValues[ckey]?.v1?.length == 0) ||
          (this.trueFalseLogic(currentValues[ckey], updateValues[ckey]) &&
            currentValues[ckey]?.v2 == updateValues[ckey]?.v2);
        state.push({ disabled: disabledCond });
      });
    });

    // Mandatory field should not be empty
    let activeSortValues = this.props.activeSortFilters.filter(
      (element) => element.elementMandatory
    );
    let activeFilterValues = this.props.activeFilters.filter(
      (element) => element.elementMandatory
    );
    let mandatoryValues = [...activeFilterValues, ...activeSortValues];
    let mandatoryState = [];
    mandatoryValues.forEach((mandatoryItem) => {
      if (currentValues[mandatoryItem.elementId]?.v1?.length > 0) {
        mandatoryState.push("true");
      } else {
        mandatoryState.push("false");
      }
    });

    if (mandatoryState.includes("false")) {
      return true;
    }

    // FROM-TO value validations / multitext i.e. principle multiple-> may be @1, @2
    let toFromFieldsState = [];
    let toFromFields = this.state.duplicateSortedFilterList?.filter(
      (item) =>
        item.elementCategoryName == "FROM-TO" &&
        item.elementTypeName == "CURRENCYRANGE"
    ) || [];
    toFromFields.forEach((item) => {
      let element = currentValues[item.elementId];
      if (!(element?.v1?.length > 0 || element?.v2?.length > 0)) {
        // v1 and v2 empty then update btn enabled
        return false;
      } else {
        if (element?.v1?.length > 0 && element?.v2?.length > 0) {
          toFromFieldsState.push("true");
        } else {
          toFromFieldsState.push("false");
        }
      }
    });
    if (toFromFieldsState.includes("false")) {
      return true;
    }

    // default conditon ( switch not used because  "elementCategoryName" and "elementTypeName" need to check)
    return state.filter((item) => !item.disabled).length > 0 ? false : true;
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.isUpdate && !this.state.isClearAll) {
      setTimeout(() => {
        this.setState({}, () =>
          this.setState({
            createUpdateButtonDisabled:
              this.updateButtonDisabledLogic(nextProps),
          })
        );
      }, 550);
    } else {
      setTimeout(() => {
        this.setState({}, () =>
          this.setState({
            createUpdateButtonDisabled: this.createButtonDisabledLogic(),
          })
        );
      }, 550);
    }

    if (
      JSON.stringify(nextProps.updateValues).length !==
      JSON.stringify(this.props.updateValues).length
    ) {
      this.setState({}, () =>
        this.setState(
          {
            currentValues: {
              ...this.mapToCurrentValue(),
            },
            isSortFilterAvailable: true,
          })
      );
    }

    if (
      this.props.filterList.length != nextProps.filterList.length ||
      (this.props.filterList &&
        nextProps.filterList &&
        JSON.stringify(this.props.filterList) !=
          JSON.stringify(nextProps.filterList)) ||
      this.props.availableFilters.length !==
        nextProps.availableFilters.length ||
      JSON.stringify(nextProps.updateValues).length !==
        JSON.stringify(this.props.updateValues).length
    ) {
      let uniqueFilterListTemp = nextProps.filterList.map((i) => {
        if (i.elementTypeName == "DYNAMIC_MULTITEXT") {
          if (!i.updatedId.includes("@")) {
            return { ...i, updatedId: `${i.elementId}@1` };
          } else {
            return i;
          }
        } else {
          return i;
        }
      });
      let ids = uniqueFilterListTemp.map((i) => {
        return i.updatedId;
      });
      let uniqueFilterList = uniqueFilterListTemp.filter((item, index) => {
        let lastIndex = ids.lastIndexOf(item.updatedId);
        return index == lastIndex;
      });

      this.setState({
        showMoreFilters: uniqueFilterList.length > 6,
      });
      const newSortedFilterList = this.getCurrentlyShownFilters(
        uniqueFilterList,
        uniqueFilterList.length > 6 ? true : false
      );
      let cq_base_queue = [];
      let groupSearchElememts = [];
      let newSortedFilterListSelected = [];
      newSortedFilterList.map((element) => {
        if (element.elementTypeName == "GROUP_SEARCH") {
          if (element.elementId == "cq_base_queue") {
            cq_base_queue.push(element);
          } else {
            groupSearchElememts.push(element);
          }
        } else {
          newSortedFilterListSelected.push(element);
        }
      });

      let resultValue = groupSearchElememts?.map((item) => {
        let tempValue = item.filterValues?.map((value) => {
          let innerItemSelectedArray = [];
          let currentValueContainsItem = false;
          let innerValueItems = value.items?.map((val) => {
            if (
              Object.prototype.toString.call(
                this.state.currentValues[item.elementId]?.v1[0]
              ) === "[object Object]" &&
              item.elementId === "cq_reason_code"
            )
              currentValueContainsItem = this.state.currentValues[
                item.elementId
              ]?.v1.some((e) => e.id === val.id && e.groupId === val.groupId);
            else
              currentValueContainsItem = this.state.currentValues[
                item.elementId
              ]?.v1.includes(val.id);

            innerItemSelectedArray.push(`${currentValueContainsItem}`);
            return { ...val, selected: currentValueContainsItem };
          });

          return {
            ...value,
            items: innerValueItems,
            isIndeterminate:
              innerItemSelectedArray.includes(`true`) &&
              innerItemSelectedArray.includes(`false`),
            selected:
              innerItemSelectedArray.includes(`true`) &&
              !innerItemSelectedArray.includes(`false`),
          };
        });
        return { ...item, filterValues: tempValue };
      });

      let header = "Select Base Queue";
      let sub = "";
      let tempSortedFilterListSelected = [
        ...newSortedFilterListSelected,
        ...resultValue,
      ];
      let updateValState =
        this.state.currentValues["cq_base_queue"]?.v1?.split(" - ");
      let updateValProps = nextProps.updateValues.filter(
        (item) => item.elementId == "cq_base_queue"
      );
      let updateVal = updateValState
        ? updateValState
        : updateValProps.length > 0
        ? updateValProps[0].v1?.split(" - ")
        : [];
      let headerVal = updateVal != null ? updateVal[0] : "";
      let subVal = updateVal != null ? updateVal[1] : "";

      let cq_base_queueValues =
        cq_base_queue?.length > 0 &&
        cq_base_queue[0]?.filterValues?.map((item) => {
          return {
            ...item,
            items: item.items.map((i) => {
              if (i.groupId == headerVal && i.id == subVal) {
                header = `${i.groupName} -`;
                sub = i.text;
              }
              return {
                ...i,
                selected: i.groupId == headerVal && i.id == subVal,
              };
            }),
          };
        });
      let newcq_base_queue =
        cq_base_queue?.length > 0
          ? [
              {
                ...cq_base_queue[0],
                customPlaceHolder: `${header} ${sub}`,
                filterValues: cq_base_queueValues,
              },
            ]
          : [];
      newSortedFilterListSelected = this.sortFilters([
        ...tempSortedFilterListSelected,
        ...newcq_base_queue,
      ]);
      this.setState({}, () => {
        this.setState({
          sortedFilterList: newSortedFilterListSelected,
          duplicateSortedFilterList: newSortedFilterListSelected,
          availableFilters: nextProps.availableFilters,
          visibleCount: newSortedFilterListSelected.length,
        });
        this.handleClickOutside();
        this.handleSecSortClickOutside();
      });
    }

    if (
      this.props.exclusionFilterList.length !=
        nextProps.exclusionFilterList.length ||
      (this.props.exclusionFilterList &&
        nextProps.exclusionFilterList &&
        JSON.stringify(this.props.exclusionFilterList) !=
          JSON.stringify(nextProps.exclusionFilterList)) ||
      this.props.availableExclusionFilters.length !==
        nextProps.availableExclusionFilters.length
    ) {
      let exclusionFilterListTemp = nextProps.exclusionFilterList.map((i) => {
        if (i.elementTypeName == "DYNAMIC_MULTITEXT") {
          if (!i.updatedId.includes("@")) {
            return { ...i, updatedId: `${i.elementId}@1` };
          } else {
            return i;
          }
        } else {
          return i;
        }
      });
      let sortedExclusionFilterListIds = exclusionFilterListTemp.map((i) => {
        return i.updatedId;
      });
      let uniqueExclusionFilterList = exclusionFilterListTemp.filter(
        (item, index) => {
          let lastIndex = sortedExclusionFilterListIds.lastIndexOf(
            item.updatedId
          );
          return index == lastIndex;
        }
      );
      this.setState({
        showMoreExclusionFilters: uniqueExclusionFilterList.length > 6,
      });
      const newSortedxclusionFilterList = this.getExclusionShownFilters(
        uniqueExclusionFilterList,
        uniqueExclusionFilterList.length > 6
      );

      let cq_ex_corp_region = [];
      let tempNewSortedxclusionFilterList = newSortedxclusionFilterList?.filter(
        (elm) => {
          if (elm?.elementId == "cq_ex_corp_region") {
            cq_ex_corp_region.push(elm);
          } else {
            return elm;
          }
        }
      );
      let selectedCorpRegionCode = [];
      let corp = [];
      let region = [];
      let corpRegion = [];
      let currentValuesCqExCorp = this.state.currentValues["cq_ex_corp_region"];
      currentValuesCqExCorp?.v1.forEach((cr) => {
        corp.push(cr.split("-")[0].trim());
        region.push(cr.split("-")[1].trim());
        corpRegion.push({
          corp: cr.split("-")[0].trim(),
          region: cr.split("-")[1].trim(),
        });
      });
      let new_cq_ex_corp_region = cq_ex_corp_region?.map((item) => {
        let exTempValue = item.filterValues?.map((value) => {
          let exInnerItemSelectedArray = [];
          let exInnerValueItems = value.items?.map((val) => {
            let exCurrentValueContainsItem = currentValuesCqExCorp?.v1.includes(
              `${value?.key} - ${val?.id}`
            );
            if (exCurrentValueContainsItem) {
              selectedCorpRegionCode.push({
                ...val,
                selected: exCurrentValueContainsItem,
              });
            }
            exInnerItemSelectedArray.push(`${exCurrentValueContainsItem}`);
            return { ...val, selected: exCurrentValueContainsItem };
          });
          return {
            ...value,
            items: exInnerValueItems,
            isIndeterminate:
              exInnerItemSelectedArray.includes(`true`) &&
              exInnerItemSelectedArray.includes(`false`),
            selected:
              exInnerItemSelectedArray.includes(`true`) &&
              !exInnerItemSelectedArray.includes(`false`),
          };
        });
        return { ...item, filterValues: exTempValue };
      });

      let newSortedExclusionFilterList = this.sortFilters([
        ...new_cq_ex_corp_region,
        ...tempNewSortedxclusionFilterList,
      ]);

      this.setState(
        {
          sortedExclusionFilterList: newSortedExclusionFilterList,
          duplicateSortedExclusionFilterList: newSortedExclusionFilterList,
          availableExclusionFilters: nextProps.availableExclusionFilters,
          exclusionVisibleCount: newSortedExclusionFilterList.length,
          selectedCorpRegionCode: [
            ...this.state.selectedCorpRegionCode,
            ...selectedCorpRegionCode,
          ],
          corpRegion,
          corp,
          region,
        },
        () => this.handleExclusionClickOutside()
      );
    }
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.scrollFilterClose);
  }

  attachBindings() {
    this.openSingleListSelector = this.openSingleListSelector.bind(this);
    this.removeAllExclusions = this.removeAllExclusions.bind(this);
    this.openExclusionList = this.openExclusionList.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleSecSortClickOutside = this.handleSecSortClickOutside.bind(this);
    this.handleExclusionClickOutside =
      this.handleExclusionClickOutside.bind(this);
    this.removeFilterAction = this.removeFilterAction.bind(this);
    this.removeExclusionFilterAction =
      this.removeExclusionFilterAction.bind(this);
    this.toggleSearchDropDown = this.toggleSearchDropDown.bind(this);
    this.toggleExclusionSearchDropDown =
      this.toggleExclusionSearchDropDown.bind(this);
    this.toggleCollapse = this.toggleCollapse.bind(this);
    this.toggleExclusionCollapse = this.toggleExclusionCollapse.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    this.handleExclusionOutsideClick =
      this.handleExclusionOutsideClick.bind(this);
    this.searchReasonCode = this.searchReasonCode.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeCommon = this.handleChangeCommon.bind(this);
    this.handleHeaderCheckbox = this.handleHeaderCheckbox.bind(this);
    this.handleHeaderCheckboxCommon =
      this.handleHeaderCheckboxCommon.bind(this);
    this.updateMerchantList = this.updateMerchantList.bind(this);
    this.clearFilters = this.clearFilters.bind(this);
    this.cancelResponseBanner = this.cancelResponseBanner.bind(this);
    this.closeBanner = this.closeBanner.bind(this);
    this.showWarningBanner = this.showWarningBanner.bind(this);
    this.closePanel = this.closePanel.bind(this);
    this.validateInputFieldsValueRange = this.validateInputFieldsValueRange.bind(this);
  }

  getCurrentlyShownFilters = (filters, showAll) => {
    const visibleFilters = filters.map((filter) => {
      if (filter.elementId == "cq_reason_code") {
        return Object.assign({}, filter, {
          id: filter.elementId,
          placeHolder: this.props.translations.reasonCode,
        });
      } else if (filter.elementId == "cq_action_code") {
        return Object.assign({}, filter, {
          id: filter.elementId,
          placeHolder: this.props.translations.actionCode,
        });
      } else if (filter.elementId == "cq_activity_code") {
        return Object.assign({}, filter, {
          id: filter.elementId,
          placeHolder: this.props.translations.activityCode,
        });
      } else if (filter.elementId == "cq_dispute_currency") {
        return Object.assign({}, filter, {
          id: filter.elementId,
          placeHolder: this.props.translations.disputeCurrency,
        });
      } else if (filter.elementId == "cq_trnsctn_currency") {
        return Object.assign({}, filter, {
          id: filter.elementId,
          placeHolder: this.props.translations.trnsctnCurrency,
        });
      } else if (filter.elementId == "cq_sttlmnt_crrncy") {
        return Object.assign({}, filter, {
          id: filter.elementId,
          placeHolder: this.props.translations.sttlmntCrrncy,
        });
      } else if (filter.elementId == "cq_dspstn_ctgry") {
        return Object.assign({}, filter, {
          id: filter.elementId,
          placeHolder: this.props.translations.dspstnCtgry,
        });
      } else if (filter.elementId == "cq_mcc") {
        return Object.assign({}, filter, {
          id: filter.elementId,
          placeHolder: this.props.translations.mcc,
        });
      } else if (filter.elementId == "cq_base_queue") {
        return Object.assign({}, filter, {
          id: filter.elementId,
          placeHolder: this.props.translations.baseQueue,
        });
      } else {
        return Object.assign({}, filter, {
          id: filter.elementId,
        });
      }
    });

    return showAll
      ? this.sortFilters(visibleFilters)
      : this.sortFilters(visibleFilters).slice(
          0,
          this.props.visibleFiltersCount
        );
  };

  getExclusionShownFilters = (filters, showAll) => {
    const visibleFilters = filters.map((filter) => {
      const activeExclusion = {...this.state.currentValues, ...{
        [filter.elementId]: { v1: 'Yes' },
      }};
      if (filter.elementId === "cq_ex_active") {
        this.setState({
          currentValues: activeExclusion,
          readOnly: true,
        });
      }
      if (filter.elementId == "cq_ex_corp_region") {
        return Object.assign({}, filter, {
          id: filter.elementId,
          placeHolder: this.props.translations.corpAndRegion,
        });
      } else {
        return Object.assign({}, filter, {
          id: filter.elementId,
        });
      }
    });
    return showAll
      ? this.sortFilters(visibleFilters)
      : this.sortFilters(visibleFilters).slice(
          0,
          this.props.visibleFiltersCount
        );
  };

  handleSingleSelection = (value, event) => {
    event.stopPropagation();

    const field = this.findDataAttribute(event.target);

    if (field) {
      const findFilterList = this.props.filterList.filter((filter) => {
        return filter.elementId === field;
      });
      const foundFilter = findFilterList.shift();

      if (foundFilter) {
        const newSelection = findItem(foundFilter.filterValues, value);
        const newValues = Object.assign({}, this.state.currentValues, {
          [field]: { v1: value },
        });
        if (newSelection) {
          this.setState({ currentValues: newValues });
        }
      }
    } else {
      throw new Error(
        "Could not find numeric filter ID on DOM target, parent or grandparent"
      );
    }
  };

  handleSortingSelection = (value, event) => {
    event.stopPropagation();

    const field = this.findDataAttribute(event.target);
    let filterList = [
      ...this.props.sortFilterList,
      ...this.props.availableSortFilterList,
    ];

    if (field) {
      const findFilterList = filterList.filter((filter) => {
        return filter.elementId === field;
      });
      const foundFilter = findFilterList.shift();

      if (foundFilter) {
        const newSelection = findItem(foundFilter.filterValues, value);
        const newValues = Object.assign({}, this.state.currentValues, {
          [field]: { v1: value },
        });
        if (newSelection) {
          this.setState({ currentValues: newValues });
        }
      }
    } else {
      throw new Error(
        "Could not find numeric filter ID on DOM target, parent or grandparent"
      );
    }
  };

  handleExclusionSelection = (value, event) => {
    event.stopPropagation();

    const field = this.findDataAttribute(event.target);

    if (field) {
      const findFilterList = this.props.exclusionFilterList.filter((filter) => {
        return filter.elementId === field;
      });
      const foundFilter = findFilterList.shift();

      if (foundFilter) {
        const newSelection = findItem(foundFilter.filterValues, value);
        const newValues = Object.assign({}, this.state.currentValues, {
          [field]: { v1: value },
        });
        if (newSelection) {
          this.setState({ currentValues: newValues });
        }
      }
    } else {
      throw new Error(
        "Could not find numeric filter ID on DOM target, parent or grandparent"
      );
    }
  };

  handleSingleDateChange = (id, value) => {
    let newValue;
    const valueFound = false;

    if (valueFound === false) {
      newValue = Object.assign({}, this.state.currentValues, {
        [id]: { v1: moment(value).format("MM/DD/YYYY") },
      });
    }

    this.setState({
      currentValues: newValue,
    });
  };

  findDataAttribute(domNode) {
    // let name = domNode.dataset.name;
    let name = domNode.getAttribute("data-name");

    if (!name) {
      name = domNode.parentElement.getAttribute("data-name");
      // name = domNode.parentElement.dataset.name;
    }

    if (!name) {
      // name = domNode.parentElement.parentElement.dataset.name;
      name = domNode.parentElement.parentElement.getAttribute("data-name");
    }
    if (!name) {
      name = domNode.id;
    }

    return name;
  }

  updateCustomQueueSortingVal = (currentValues, sortFilterList) => {
    let currentValuesObj = this.state.currentValues;
    let filteredObj = Object.keys(currentValuesObj)
    .filter(key => key.slice(0, key.indexOf("_")) !== "sort" )
    .reduce((acc, key) => {
       acc[key] = currentValuesObj[key];
       return acc;
    }, {});

    let updatedCurrentValue = {...filteredObj, ...currentValues}

    this.setState({
      currentValues: updatedCurrentValue,
      sortFilterList: sortFilterList,
    }, () => {
      this.props.updateCustomQueueLandingVal(this.state.sortFilterList,this.state.currentValues)
    });
  }

  handleSelection = (value, event) => {
    event.stopPropagation();
    const field = this.findDataAttribute(event.target);
    if (field) {
      const findFilterList = this.props.filterList.filter((filter) => {
        return filter.elementId === field;
      });

      const foundFilter = findFilterList.shift();

      if (foundFilter) {
        const newSelection = findItem(foundFilter.filterValues, value);
        const currentMultiSelectValue = this.state.currentValues[field]
          ? this.state.currentValues[field].v1
          : [];

        const selectedItemsIndex = currentMultiSelectValue
          ? currentMultiSelectValue.indexOf(value)
          : null;

        if (selectedItemsIndex !== -1) {
          currentMultiSelectValue.splice(selectedItemsIndex, 1);
        } else {
          currentMultiSelectValue.push(newSelection.value);
        }

        const newValues = Object.assign({}, this.state.currentValues, {
          [field]: { v1: currentMultiSelectValue },
        });
        if (newSelection) {
          this.setState({
            currentValues: newValues,
          });
        }
      }
    } else {
      throw new Error(
        "Could not find numeric filter ID on DOM target, parent or grandparent"
      );
    }
  };

  sortFilters = (filterList = []) => {
    return filterList.sort((filterA, filterB) => {
      return (
        Number(filterA.elementSequenceNumber) -
        Number(filterB.elementSequenceNumber)
      );
    });
  };

  get displayFilterList() {
    return (
      this.state.sortedFilterList &&
      this.state.sortedFilterList.length !== 0 &&
      this.state.sortedFilterList
        .filter((filtr) => filtr.elementId !== "merchant_hierarchy")
        .map((filter, index) => {
          return (
            <FilterElement
              searchWithFullPan={
                filter.elementTypeName === "FULL_CC_NUMBER"
                  ? this.props.userPermission &&
                    this.props.userPermission.case.searchWithFullPan
                  : true
              }
              currentValues={
                this.state.currentValues[
                  this.props.showDynamicFilter
                    ? filter.updatedId
                    : filter.elementId
                ]
              }
              dateFormat={this.props.dateFormat}
              filter={filter}
              handleDualDates={this.handleDualDates}
              handleMonthChange={this.handleMonthChange}
              handleSelection={this.handleSelection}
              handleSingleSelection={this.handleSingleSelection}
              key={index}
              currentSearchTerm={this.state[filter.elementId]} //defect id 45 => for value getting autometically added for reason code field
              onChange={this.updateFormState}
              onCurrencyChange={this.updateCurrencyState}
              onRangeChange={this.handleRangeChange}
              translations={this.props.translations}
              id={`${this.props.reportName}_filterElement`}
              language={this.props.language}
              reportKey={this.props.reportKey}
              onSingleDateChange={this.handleSingleDateChange}
              extraClass={this.props.appSearchElement}
              removeFilterAction={this.removeFilterAction}
              showDynamicFilter={
                filter.elementId != "cq_name" && this.props.showDynamicFilter
              }
              updatedId={filter.updatedId}
              handleOutsideClick={this.handleOutsideClick}
              toggleCollapse={this.toggleCollapse}
              toggleSearchDropDown={this.toggleSearchDropDown}
              searchReasonCode={this.searchReasonCode}
              visible={this.state.visible}
              handleChange={this.handleChange}
              handleHeaderCheckbox={this.handleHeaderCheckbox}
              updateIsIndeterminate={this.props.updateIsIndeterminate}
              // currentSearchTerm={this.state.currentSearchTerm}
              isMerchantUser={this.props.isMerchantUser}
              listHeight={this.props.listHeight}
              index={this.state.index}
            />
          );
        })
    );
  }

  displaySortFilterList(sortFilter) {
    return (
      sortFilter &&
      sortFilter.length !== 0 &&
      sortFilter
        .filter((filtr) => filtr.elementId !== "merchant_hierarchy")
        .map((filter, index) => {
          return (
            <FilterElement
              currentValues={
                this.state.currentValues[
                  this.props.showDynamicFilter
                    ? filter.elementId
                    : filter.elementId
                ]
              }
              dateFormat={this.props.dateFormat}
              isSortFilter={true}
              filter={filter}
              handleDualDates={this.handleDualDates}
              handleMonthChange={this.handleMonthChange}
              handleSelection={this.handleSelection}
              handleSingleSelection={this.handleSortingSelection}
              key={index}
              currentSearchTerm={this.state[filter.elementId]}
              onChange={this.updateFormState}
              onCurrencyChange={this.updateCurrencyState}
              onRangeChange={this.handleRangeChange}
              translations={this.props.translations}
              id={`${this.props.reportName}_sortFilterElement`}
              language={this.props.language}
              reportKey={this.props.reportKey}
              onSingleDateChange={this.handleSingleDateChange}
              extraClass={this.props.appSearchElement}
              removeFilterAction={this.removeFilterAction}
              showDynamicFilter={this.props.showDynamicFilter}
              updatedId={filter.updatedId}
              handleOutsideClick={this.handleOutsideClick}
              toggleCollapse={this.toggleCollapse}
              toggleSearchDropDown={this.toggleSearchDropDown}
              searchReasonCode={this.searchReasonCode}
              visible={this.state.visible}
              handleChange={this.handleChange}
              handleHeaderCheckbox={this.handleHeaderCheckbox}
              updateIsIndeterminate={this.props.updateIsIndeterminate}
              isMerchantUser={this.props.isMerchantUser}
              listHeight={this.props.listHeight}
              index={this.state.index}
            />
          );
        })
    );
  }

  displayExclusionFilterList(exclusionFilter) {
    return (
      exclusionFilter &&
      exclusionFilter.length !== 0 &&
      exclusionFilter
        .filter((filtr) => filtr.elementId !== "merchant_hierarchy")
        .map((filter, index) => {
          return (
            <FilterElement
              currentValues={
                this.state.currentValues[
                  this.props.showDynamicFilter
                    ? filter.updatedId
                    : filter.elementId
                ]
              }
              dateFormat={this.props.dateFormat}
              isExclusionFilter={true}
              filter={filter}
              handleDualDates={this.handleDualDates}
              handleMonthChange={this.handleMonthChange}
              handleSelection={this.handleSelection}
              handleSingleSelection={this.handleExclusionSelection}
              key={index}
              currentSearchTerm={this.state[filter.elementId]}
              onChange={this.updateFormState}
              onCurrencyChange={this.updateCurrencyState}
              onRangeChange={this.handleRangeChange}
              translations={this.props.translations}
              id={`${this.props.reportName}_exclusionFilterElement`}
              language={this.props.language}
              reportKey={this.props.reportKey}
              onSingleDateChange={this.handleSingleDateChange}
              extraClass={this.props.appSearchElement}
              removeFilterAction={this.removeExclusionFilterAction}
              showDynamicFilter={this.props.showDynamicFilter}
              updatedId={filter.updatedId}
              handleOutsideClick={this.handleExclusionOutsideClick}
              toggleCollapse={this.toggleExclusionCollapse}
              toggleSearchDropDown={this.toggleExclusionSearchDropDown}
              searchReasonCode={this.searchReasonCode}
              visible={this.state.visible}
              handleChange={this.handleChange}
              handleHeaderCheckbox={this.handleHeaderCheckbox}
              updateIsIndeterminate={this.props.updateIsIndeterminate}
              isMerchantUser={this.props.isMerchantUser}
              listHeight={this.props.listHeight}
              index={this.state.index}
              readOnly={this.state.readOnly}
            />
          );
        })
    );
  }

  removeFilterAction(identifier) {
    const { availableFilters, sortedFilterList, sortedFilterErrors } = this.state;
    const filterToRemove = sortedFilterList.find(
      (filter) => filter.updatedId === identifier
    );
    if(filterToRemove?.errorMsg) {
      filterToRemove.errorMsg = '';
    }
    const updatedSortedFilterErrors = sortedFilterErrors;
    if(updatedSortedFilterErrors[identifier]) {
      delete updatedSortedFilterErrors[identifier]
    }
    const updatedCurrentValues = Object.assign(
      {},
      delete this.state.currentValues[filterToRemove.updatedId],
      this.state.currentValues
    );
    if (filterToRemove) {
      const newActiveColumns = sortedFilterList.filter(
        (filter) => filter.updatedId !== identifier
      );
      let newAvailableColumns = availableFilters;
      
        newAvailableColumns = sortColumnsByInt(
          [...availableFilters, filterToRemove],
          "elementSequenceNumber"
        );
      
      this.state.sortedFilterList.map((element) => {
        if (element.elementTypeName === "GROUP_SEARCH") {
          if (element.elementId == identifier) {
            for (let i = 0; i < element.filterValues.length; i++) {
              element.filterValues[i].selected = false;
              let items = element.filterValues[i].items;
              for (let j = 0; j < items.length; j++) {
                items[j].selected = false;
              }
            }
          }
        }
      });

      this.setState(
        {
          availableFilters: newAvailableColumns,
          sortedFilterList: newActiveColumns,
          sortedFilterErrors: updatedSortedFilterErrors,
          [identifier]: "",
          currentSearchTerm: "",
        },
        () => {
          this.props.updateColumnsInfo({
            availableColumns: newAvailableColumns,
            activeColumns: newActiveColumns,
            identifier,
            currentValues: updatedCurrentValues,
            filterList: this.props.filterList,
          });
        }
      );
    }
  }

  removeExclusionFilterAction(identifier) {
    const { availableExclusionFilters, sortedExclusionFilterList } = this.state;
    const filterToRemove = sortedExclusionFilterList.find(
      (column) => column.updatedId === identifier
    );
    const updatedCurrentValues = Object.assign(
      {},
      delete this.state.currentValues[filterToRemove.updatedId],
      this.state.currentValues
    );
    if (filterToRemove) {
      const newExclusionActiveColumns = sortedExclusionFilterList.filter(
        (column) => column.updatedId !== identifier
      );
      let newExclusionAvailableColumns = availableExclusionFilters;
      
        newExclusionAvailableColumns = sortColumnsByInt(
          [...availableExclusionFilters, filterToRemove],
          "elementSequenceNumber"
        );
      
      this.state.sortedExclusionFilterList.map((element) => {
        if (element.elementTypeName === "GROUP_SEARCH") {
          if (element.elementId == identifier) {
            for (let i = 0; i < element.filterValues.length; i++) {
              element.filterValues[i].selected = false;
              let items = element.filterValues[i].items;
              for (let j = 0; j < items.length; j++) {
                items[j].selected = false;
              }
            }
          }
        }
      });

      this.setState(
        {
          availableExclusionFilters: newExclusionAvailableColumns,
          sortedExclusionFilterList: newExclusionActiveColumns,
          [identifier]: "",
          currentSearchTerm: "",
        },
        () => {
          this.props.updateExclusionColumnsInfo({
            availableColumns: newExclusionAvailableColumns,
            activeColumns: newExclusionActiveColumns,
            identifier,
            currentValues: updatedCurrentValues,
            filterList: this.props.activeExclusionFilters,
          });
        }
      );
    }
  }

  // This method is used for validate input field on change.
  validateInputField(fieldName, fieldValue) {
    let fieldError = '';
    this.state.sortedFilterList.forEach((filter) => {
      const currentFilterID = filter?.updatedId || filter?.elementId;
      if (currentFilterID === fieldName) {
        if (filter?.elementMandatory && fieldValue === '') {
          fieldError = 'This field is required.';
        } else if (fieldValue && filter?.validate) {
          const errMsg = filter?.validate(fieldValue);
          if (errMsg) {
            fieldError = errMsg;
          }
          else if(filter?.min && fieldValue?.length !== 0 && fieldValue?.length !== filter?.min) {
            fieldError = `The minimum length required for this field is ${filter?.min} characters.`;
          }
        }
      }
    });
    return fieldError;
  }

  // This method is used for validate value range input field on change.
  validateInputFieldsValueRange(id, selector, value) {
    const {v1="00.00", v2="00.00"} = this.state.currentValues[id] || {};
    const valueArr = value.split(".");
    const v1Arr = v1.split(".");
    const v2Arr = v2.split(".");
    if(selector === 'start') {
      if(+(valueArr[0]) > +(v2Arr[0])) {
        return "The 'From' value must be smaller than the 'To' value.";
      } else if(+(valueArr[0]) === +(v2Arr[0])) {
        if(+(valueArr[1]?.length > 1 ?  valueArr[1] : `${valueArr[1]||0}0` ) > +(v2Arr[1]?.length > 1 ?  v2Arr[1] : `${v2Arr[1]||0}0` )) {
          return "The 'From' value must be smaller than the 'To' value.";
        }
      }
    } else {
      if(+(v1Arr[0]) > +(valueArr[0])) {
        return "The 'From' value must be smaller than the 'To' value.";
      } else if(+(v1Arr[0]) === +(valueArr[0])) {
        if(+(v1Arr[1]?.length > 1 ?  v1Arr[1] : `${v1Arr[1]||0}0` ) > +(valueArr[1]?.length > 1 ?  valueArr[1] : `${valueArr[1]||0}0`)) {
          return "The 'From' value must be smaller than the 'To' value.";
        }
      }
    }
    return '';
  }

  /**
   * handler called by STRING type filters to update the input value in state
   * @param    {Event} event standard synthetic React event wrapper around DOM event
   * @modifies {state}       updates the matching value in currentValues array in component state
   *
   * @description each value object for a STRING looks like this:
   *                {"id":267, "v1":"last_year", "type":"EXACT"}
   *                where id = filter ID
   *                      v1 = the single value
   *                      type = match type
   */
  updateFormState = (event) => {
    const fieldName = event?.target?.name;
    let fieldValue = event?.target?.value;
    const fieldError = this.validateInputField(fieldName, fieldValue);
    const updatedSortedFilterErrors = { ...this.state.sortedFilterErrors };

    const updatedSortedFilterList = this.state?.sortedFilterList?.map((filter) => {
      const currentFilterID = filter?.updatedId || filter?.elementId;
      if (currentFilterID === fieldName) {
        filter.errorMsg = fieldError;
      }
      return filter;
    });

    if (fieldError) {
      updatedSortedFilterErrors[fieldName] = fieldError;
    } else {
      delete updatedSortedFilterErrors[fieldName];
    }

    if (fieldName == "cq_name") {
      fieldValue = fieldValue.replace(/^\s$/, "");
    } 

    const updatedCurrentValues = {...this.state.currentValues, [fieldName]: { v1: fieldValue }}
 
    if (fieldValue === "" && fieldName !== "cq_name") {
      delete updatedCurrentValues[fieldName];
    }

    this.setState({
      currentValues: updatedCurrentValues,
      sortedFilterList: updatedSortedFilterList,
      sortedFilterErrors: updatedSortedFilterErrors
    });
  };

  /**
   * handler called by CURRENCYEXACT type filter/s to update the input value in state
   * @param    {Event} event standard synthetic React event wrapper around DOM event
   * @modifies {state}       updates the matching value in currentValues array in component state
   * NOTE : Need this handler as string update event takes different parameters as compared to CURRENCEXACT.
   *        Since it is a generic component and is used in multiple places, thi code is required
   * @description each value object for a CURRENCYEXACT looks like this:
   *                {"id":267, "v1":"last_year", "type":"CURRENCYEXACT"}
   *                where id = filter ID
   *                      v1 = the single value
   *                      type = match type
   */
  updateCurrencyState = (value, id) => {
    value = value ? value.trim() : value;

    const newValues = Object.assign({}, this.state.currentValues, {
      [id]: { v1: value },
    });
    if (value === "") {
      delete newValues[id];
    }

    this.setState({
      currentValues: newValues,
    });
  };

  /**
   * handler called by Range type filters (CURRENCY, DATE) to update the input value in state
   * @param    {number} id       the database ID of the matching filter
   * @param    {string} selector 'start' for the first value (v1),'end' for second value (v2)
   * @param    {string} value    the value to use
   * @modifies {state}           updates the matching value in currentValues array in component state
   *
   * @description each value object for a STRING looks like this:
   *                {"id":267, "v1":"last_year", "type":"EXACT"}
   *                where id = filter ID
   *                      v1 = the single value
   *                      type = match type
   */
  handleRangeChange = (id, selector, value) => {
    const updatedSortedFilterErrors = { ...this.state.sortedFilterErrors};
    const fieldError = this.validateInputField(id, value);
    if(!updatedSortedFilterErrors[id]) {
      updatedSortedFilterErrors[id] = {};
    } 
    updatedSortedFilterErrors[id][selector] = fieldError;
    updatedSortedFilterErrors[id]['valueRangeError'] = this.validateInputFieldsValueRange(id, selector, value);

    const updatedSortedFilterList = this.state?.sortedFilterList?.map((filter) => {
      if (filter?.elementId === id) {
        filter.errorMsg = updatedSortedFilterErrors[id]?.start || updatedSortedFilterErrors[id]?.end || updatedSortedFilterErrors[id]['valueRangeError'] || "";
      }
      return filter;
    });

    if(!updatedSortedFilterErrors[id]?.start && !updatedSortedFilterErrors[id]?.end && !updatedSortedFilterErrors[id]['valueRangeError']) {
      delete updatedSortedFilterErrors[id];
    }

    const key = selector === "end" ? "v2" : "v1";
    const currentRange = this.state.currentValues[id] || {};
    const newValue = value.trim() === "" ? undefined : value.trim();

    // set newRange to undefined if v1 and v2 are both undefined
    let newRange = Object.assign(currentRange, { [key]: newValue });
    if (newRange.v1 === undefined && newRange.v2 === undefined) {
      newRange = undefined;
    }

    // update newValues
    let newValues = Object.assign({}, this.state.currentValues, {
      [id]: newRange,
    });

    // remove id key from newValues if newRange is undefined > cleanup newValues
    const ids = this.state.currentValues[id];
    if (ids !== undefined && newRange === undefined) {
      const { [id.toString()]: omit, ...rest } = newValues;
      newValues = rest;
    }

    const currentId = newValues[id];
    if (
      currentId !== undefined &&
      ((currentId.v1 === null && currentId.v2 === null) ||
        (currentId.v1 === "" && currentId.v2 === ""))
    ) {
      delete newValues[id];
    }

    this.setState({
      currentValues: newValues,
      sortedFilterList: updatedSortedFilterList,
      sortedFilterErrors: updatedSortedFilterErrors
    });
  };

  handleDualDates = (id, dualValues) => {
    this.props.deleteAlertPrefsByAlertkey(types.REPORT_VALIDATION);
    // find or create filter values obj
    const targetValues = this.state.currentValues[id] || {};
    // copy current values
    const newValues = Object.assign({}, this.state.currentValues, {
      [id]: targetValues,
    });

    // decide type
    if (dualValues.startDate && dualValues.endDate) {
      targetValues.type = "BETWEEN";
    } else if (dualValues.startDate) {
      targetValues.type = "STARTS_WITH";
    } else if (dualValues.endDate) {
      targetValues.type = "ENDS_WITH";
    } else {
      targetValues.type = "DELETE";
    }
    if (targetValues.type === "DELETE") {
      // remove obj if both values are missing
      delete newValues[id];
    } else {
      // otherwise, update to new values
      // const target = newValues[id];
      targetValues.v1 = dualValues.startDate;
      targetValues.v2 = dualValues.endDate;
    }
    targetValues.error = "";
    targetValues.flag = false;
    const currentCalenderValues = [
      {
        id,
        v1: dualValues.startDate,
        v2: dualValues.endDate,
        type: targetValues.type,
      },
    ];
    validateFiltersAgainstValidationRule(
      this.props.filterList,
      currentCalenderValues,
      this.props.dateFormat
    ).then((currentValues) => {
      const modfiedObject = currentValues.find((currentValue) => {
        return id === currentValue.id;
      });
      if (modfiedObject.error) {
        Object.assign(targetValues, {
          error: modfiedObject.error,
          flag: modfiedObject.flag,
        });
        this.props.setAlertPrefs([
          {
            showAlert: true,
            msgAlertType: "danger",
            displayText: targetValues.error,
            alertKey: types.REPORT_VALIDATION,
          },
        ]);
      }
      this.setState({
        currentValues: newValues,
      });
    });
  };

  handleMonthChange = (id, value) => {
    const targetValues = this.state.currentValues[id] || {};
    targetValues.v1 = value;

    // copy current values
    const newValues = Object.assign({}, this.state.currentValues, {
      [id]: targetValues,
    });

    this.setState({
      currentValues: newValues,
    });
  };

  toggleFilters = () => {
    const newShowStatus = !this.state.showMoreFilters;
    const newSortedFilterList = this.getCurrentlyShownFilters(
      this.state.duplicateSortedFilterList,
      newShowStatus
    );
    this.setState({
      showMoreFilters: newShowStatus,
      sortedFilterList: newSortedFilterList,
    });
    if (document.getElementById("case-body")) {
      if (newShowStatus === true) {
        document.getElementById("case-body").style.maxHeight = "286px";
      } else {
        document.getElementById("case-body").style.maxHeight = "200px";
      }
    }
  };

  toggleExclusionFilters = () => {
    const newShowStatus = !this.state.showMoreExclusionFilters;
    const newExclusionFilterList = this.getExclusionShownFilters(
      this.state.duplicateSortedExclusionFilterList,
      newShowStatus
    );
    this.setState({
      showMoreExclusionFilters: newShowStatus,
      sortedExclusionFilterList: newExclusionFilterList,
    });
    if (document.getElementById("case-body")) {
      if (newShowStatus === true) {
        document.getElementById("case-body").style.maxHeight = "286px";
      } else {
        document.getElementById("case-body").style.maxHeight = "200px";
      }
    }
  };

  removeNonMandatoryCreateQueue = () => {
    let sortedFilterList = this.state.sortedFilterList.filter(
      (item) => item.elementMandatory
    );
    this.setState({ sortedFilterList });
    // refer removeFilterAction and removeAllExclusions
  };

  clearFilters = () => {
    this.setState(
      {
        currentValues: {},
        currentSearchTerm: "",
        corp: [],
        region: [],
        corpRegion: [],
        selectedReasonCode: [],
        selectedCorpRegionCode: [],
        selectedActionCode: [],
        selectedActivityCode: [],
        selectedDispCategory: [],
        selectedDisputeCurr: [],
        selectedMccCode: [],
        selectedTransactionCurr: [],
        selectedSettlementCurr: [],
        merchant_hierarchy_reset: true,
        isClearAll: true,
        sortedFilterErrors: {},
      },
      () => {
        this.props.clearAllFilters();
        this.state.sortedFilterList.map((element) => {
          if (element.elementTypeName === "GROUP_SEARCH") {
            for (let i = 0; i < element.filterValues.length; i++) {
              element.filterValues[i].selected = false;
              let items = element.filterValues[i].items;
              for (let j = 0; j < items.length; j++) {
                items[j].selected = false;
              }
            }
          }
          if (element.elementId === "cq_base_queue") {
            element.customPlaceHolder = "Select Base Queue";
          }
          if(element?.errorMsg) {
            element.errorMsg = '';
          }
        });
        this.state.sortedExclusionFilterList.map((element) => {
          if (element.elementTypeName === "GROUP_SEARCH") {
            for (let i = 0; i < element.filterValues.length; i++) {
              element.filterValues[i].selected = false;
              let items = element.filterValues[i].items;
              for (let j = 0; j < items.length; j++) {
                items[j].selected = false;
              }
            }
          }
        });
      }
    );
  };

  applyFilters = () => {
    if (this.props.canViewHierarchySelector) {
      let merchant_hierarchy = Object.assign({}, this.state.merchant_hierarchy);
      this.state.currentValues.merchant_hierarchy = merchant_hierarchy;
    }
    let sortingFilters = this.state.sortFilterList;
    let newValues = [];
    let updatedCurrentValue = this.state.currentValues;
    let filterCodeFilters = this.state.duplicateSortedFilterList?.find(
      (sortedFilter) => sortedFilter.elementId == "cq_reason_code"
    );
    if (
      filterCodeFilters &&
      Object.prototype.toString.call(
        this.state.currentValues["cq_reason_code"]?.v1[0]
      ) !== "[object Object]"
    ) {
      let elementState = [];
      filterCodeFilters.filterValues.map((filterValue) => {
        filterValue.items.map((filterItem) => {
          if (filterItem.selected) {
            if (
              this.state.currentValues &&
              this.state.currentValues["cq_reason_code"] &&
              this.state.currentValues["cq_reason_code"].v1 &&
              this.state.currentValues["cq_reason_code"].v1.findIndex(
                (val) => val == filterItem.id
              ) != -1
            ) {
              elementState = elementState.concat(filterItem);
            }
          }
        });
      });
      elementState = Array.from(new Set(elementState));
      let newSelection = elementState.map((item) => {
        return { id: item.value, groupId: item.groupId };
      });
      newValues = Object.assign({}, this.state.currentValues, {
        ["cq_reason_code"]: { v1: newSelection },
      });
    }

    this.props.applyFilters(
      Object.keys(newValues).length > 0 ? newValues : updatedCurrentValue,
      this.state.duplicateSortedFilterList,
      sortingFilters,
      this.state.duplicateSortedExclusionFilterList,
      this.state.corp,
      this.state.region,
      this.state.corpRegion
    );
    if (this.state.showMoreFilters) {
      this.toggleFilters();
    }
    if (this.state.showMoreExclusionFilters) {
      this.toggleExclusionFilters();
    }
  };

  scrollFilterClose() {
    const filterElement = document.getElementById("custom-queue-filter-pane");
    const trigger =
      filterElement.getBoundingClientRect().top + filterElement.offsetHeight;

    if (trigger <= 140) {
      this.props.resetScrollPos();
      this.props.closeFilterPane();
    }
  }

  openSingleListSelector() {
    this.setState((prevState) => ({
      isSingleListSelectorOpen: !prevState.isSingleListSelectorOpen,
    }));
  }

  removeAllExclusions() {
    let newExclusionAvailableColumns = this.state.availableExclusionFilters;
    this.state.sortedExclusionFilterList.map((filterElement) => {
      let updatedCurrentValue = Object.assign(
        {},
        delete this.state.currentValues[filterElement.updatedId],
        this.state.currentValues
      );

      
        newExclusionAvailableColumns = sortColumnsByInt(
          [...this.state.availableExclusionFilters, filterElement],
          "elementSequenceNumber"
        );
      

      if (filterElement.elementTypeName === "GROUP_SEARCH") {
        if (filterElement.elementId == filterElement.updatedId) {
          for (let i = 0; i < filterElement.filterValues.length; i++) {
            filterElement.filterValues[i].selected = false;
            let items = filterElement.filterValues[i].items;
            for (let j = 0; j < items.length; j++) {
              items[j].selected = false;
            }
          }
        }
      }

      this.setState(
        {
          availableExclusionFilters: newExclusionAvailableColumns,
          sortedExclusionFilterList: [],
          [filterElement.updatedId]: "",
          currentSearchTerm: "",
          currentValues: updatedCurrentValue,
          corp: [],
          region: [],
          corpRegion: [],
          selectedCorpRegionCode: [],
        },
        () => {
          this.props.updateExclusionColumnsInfo({
            availableColumns: newExclusionAvailableColumns,
            activeColumns: [],
            identifier: [filterElement.updatedId],
            currentValues: this.state.currentValues,
            filterList: this.props.activeExclusionFilters,
          });
        }
      );
    });
  }

  openExclusionList() {
    this.setState((prevState) => ({
      isExclusionListSelectorOpen: !prevState.isExclusionListSelectorOpen,
    }));
  }

  handleClickOutside() {
    this.setState({
      isSingleListSelectorOpen: false,
    });
  }

  handleSecSortClickOutside() {
    this.setState((prevState) => ({
      isSecSortListSelectorOpen: prevState.isSecSortListSelectorOpen,
      isSortFilterAvailable: prevState.isSortFilterAvailable,
    }));
  }

  handleExclusionClickOutside() {
    this.setState({
      isExclusionListSelectorOpen: false,
    });
  }

  handleOnApplyActiveColumns = (newAvailableColumns, newActiveColumns) => {
    this.setState(
      {
        availableColumns: newAvailableColumns,
        activeColumns: newActiveColumns,
        currentActiveColumns: newActiveColumns,
      },
      () => {
        this.props.updateVisibleColumns(newActiveColumns);
      }
    );
  };

  handleOnUpdateActiveColumns = (columns) => {
    this.setState({
      currentActiveColumns: columns,
    });
  };

  handleChange(item, filterName) {
    let newSelection = [];
    let newValues = [];
    let region = [];
    let corp = [];
    let corpRegion = [];
    item.selected = !item.selected;
    let selectedCorpRegionCode = this.state.selectedCorpRegionCode
      ? this.state.selectedCorpRegionCode
      : [];

    if (filterName == "cq_reason_code") {
      newSelection = this.handleChangeCommon(
        item,
        filterName,
        "selectedReasonCode"
      );
    }
    if (filterName == "cq_action_code") {
      newSelection = this.handleChangeCommon(
        item,
        filterName,
        "selectedActionCode"
      );
    }
    if (filterName == "cq_activity_code") {
      newSelection = this.handleChangeCommon(
        item,
        filterName,
        "selectedActivityCode"
      );
    }
    if (filterName == "cq_dspstn_ctgry") {
      newSelection = this.handleChangeCommon(
        item,
        filterName,
        "selectedDispCategory"
      );
    }
    if (filterName == "cq_dispute_currency") {
      newSelection = this.handleChangeCommon(
        item,
        filterName,
        "selectedDisputeCurr"
      );
    }
    if (filterName == "cq_mcc") {
      newSelection = this.handleChangeCommon(
        item,
        filterName,
        "selectedMccCode"
      );
    }
    if (filterName == "cq_trnsctn_currency") {
      newSelection = this.handleChangeCommon(
        item,
        filterName,
        "selectedTransactionCurr"
      );
    }
    if (filterName == "cq_sttlmnt_crrncy") {
      newSelection = this.handleChangeCommon(
        item,
        filterName,
        "selectedSettlementCurr"
      );
    }
    if (filterName == "cq_base_queue") {
      newSelection = this.handleCascadeChange(item, filterName);
    }

    if (filterName === "cq_ex_corp_region") {
      if (item.selected) {
        let numberOfRecordsToAssign = 0;
        selectedCorpRegionCode.forEach((selectedUser) => {
          if (selectedUser.userId === item.userId) {
            numberOfRecordsToAssign = selectedUser.numberOfRecordsToAssign;
          }
        });
        item.numberOfRecordsToAssign = numberOfRecordsToAssign;
        selectedCorpRegionCode.push(Object.assign({}, item));
      } else {
        let reasonCodeIndex = selectedCorpRegionCode.findIndex(
          (o) => o.id == item.id && o.groupId == item.groupId
        );
        if (reasonCodeIndex > -1) {
          selectedCorpRegionCode.splice(reasonCodeIndex, 1);
        }
      }

      newSelection = selectedCorpRegionCode.map((item) => {
        return `${item.groupId} - ${item.value}`;
      });
      corp = selectedCorpRegionCode.map((item) => {
        return item.groupId;
      });
      corp = corp.filter((x, i, a) => a.indexOf(x) == i);
      region = selectedCorpRegionCode.map((item) => {
        return item.value;
      });
      corpRegion = selectedCorpRegionCode.map((item) => {
        return { corp: item.groupId, region: item.value };
      });
      this.setState({
        corp: corp,
        region: region,
        corpRegion: corpRegion,
      });
    }

    newValues = Object.assign({}, this.state.currentValues, {
      [filterName]: { v1: newSelection },
    });
    this.setState({
      currentValues: newValues,
    });
  }

  handleChangeCommon(item, filterName, filterState) {
    let elementState = this.state[filterState] ? this.state[filterState] : [];
    let filterCodeFilters = this.state.sortedFilterList.find(
      (sortedFilter) => sortedFilter.elementId == filterName
    );

    filterCodeFilters.filterValues.map((filterValue) => {
      filterValue.items.map((filterItem) => {
        if (filterItem.selected) {
          let filterIndex = elementState.findIndex(
            (selectedCodeItem) =>
              selectedCodeItem.id == filterItem.id &&
              selectedCodeItem.groupId == filterItem.groupId
          );
          if (
            filterIndex == -1 &&
            this.state.currentValues &&
            this.state.currentValues[filterName] &&
            this.state.currentValues[filterName].v1 &&
            (filterName === "cq_reason_code" &&
            Object.prototype.toString.call(
              this.state.currentValues[filterName]?.v1[0]
            ) === "[object Object]"
              ? this.state.currentValues[filterName].v1.findIndex(
                  (val) => val.id == filterItem.id
                ) != -1
              : this.state.currentValues[filterName].v1.findIndex(
                  (val) => val == filterItem.id
                ) != -1)
          ) {
            elementState = elementState.concat(filterItem);
          }
        }
      });
    });
    elementState = Array.from(new Set(elementState));

    if (item.selected) {
      let numberOfRecordsToAssign = 0;
      elementState.forEach((selectedUser) => {
        if (selectedUser.userId === item.userId) {
          numberOfRecordsToAssign = selectedUser.numberOfRecordsToAssign;
        }
      });
      item.numberOfRecordsToAssign = numberOfRecordsToAssign;
      elementState.push(Object.assign({}, item));
    } else if (item.userId && item.cardBrandName) {
      let index = elementState.findIndex(
        (o) => o.userId == item.userId && o.cardBrandName == item.cardBrandName
      );
      if (index > -1) {
        elementState.splice(index, 1);
      }
    } else {
      let filterCodeIndex = elementState.findIndex(
        (o) => o.id == item.id && o.groupId == item.groupId
      );
      if (filterCodeIndex > -1) {
        elementState.splice(filterCodeIndex, 1);
      }
    }
    return elementState.map((item) => {
      return filterName === "cq_reason_code"
        ? { id: item.value, groupId: item.groupId }
        : item.value;
    });
  }

  handleCascadeChange = (item, filterName) => {
    let newval = `${item.groupId} - ${item.id}`;
    let preSelected = this.state.currentValues[filterName]?.v1;
    let sortedFilterList = [];
    let cascadeItem = [];
    let header = "";
    let sub = "";

    if (item.selected) {
      header = `${item.groupName} -`;
      sub = item.text;
    } else if (newval == preSelected) {
      header = "Select Base Queue";
      sub = "";
    } else preSelected;

    this.state.sortedFilterList.map((i) => {
      if (i.elementId == filterName) {
        cascadeItem.push(i);
      } else {
        sortedFilterList.push(i);
      }
    });
    let newCascadeItemFilterValues = cascadeItem[0].filterValues.map((elm) => {
      if (elm.key == item.groupName) {
        return {
          ...elm,
          isIndeterminate: item.selected,
          items: elm.items.map((innerItem) => {
            if (innerItem.id == item.id) {
              return { ...innerItem, selected: item.selected };
            } else return { ...innerItem, selected: false };
          }),
        };
      } else
        return {
          ...elm,
          isIndeterminate: false,
          items: elm.items.map((innerItem) => {
            return { ...innerItem, selected: false };
          }),
        };
    });

    let newCascadeItem = {
      ...cascadeItem[0],
      customPlaceHolder: `${header} ${sub}`,
      filterValues: newCascadeItemFilterValues,
    };
    sortedFilterList = this.sortFilters([...sortedFilterList, newCascadeItem]);

    this.setState({ sortedFilterList });

    if (item.selected) {
      return newval;
    } else if (newval == preSelected) {
      return [];
    } else return preSelected;
  };

  searchReasonCode(value, filterName) {
    let updatedFilterName =
      filterName == undefined && this.state.key ? this.state.key : filterName;
    this.setState({
      [updatedFilterName]: value, //defect id 45 => for value getting autometically added for reason code field
      visible: true,
    });
  }

  handleHeaderCheckbox(item, filterName) {
    let newSelection = [];
    let newValues = [];
    let corp = [];
    let region = [];
    let corpRegion = [];
    item.isIndeterminate = false;
    each(item.items, function (user) {
      user.selected = item.selected;
    });
    let selectedCorpRegionCode = this.state.selectedCorpRegionCode
      ? this.state.selectedCorpRegionCode
      : [];

    if (filterName == "cq_reason_code") {
      newSelection = this.handleHeaderCheckboxCommon(
        item,
        filterName,
        "selectedReasonCode"
      );
    }
    if (filterName == "cq_action_code") {
      newSelection = this.handleHeaderCheckboxCommon(
        item,
        filterName,
        "selectedActionCode"
      );
    }
    if (filterName == "cq_activity_code") {
      newSelection = this.handleHeaderCheckboxCommon(
        item,
        filterName,
        "selectedActivityCode"
      );
    }
    if (filterName == "cq_dspstn_ctgry") {
      newSelection = this.handleHeaderCheckboxCommon(
        item,
        filterName,
        "selectedDispCategory"
      );
    }
    if (filterName == "cq_dispute_currency") {
      newSelection = this.handleHeaderCheckboxCommon(
        item,
        filterName,
        "selectedDisputeCurr"
      );
    }
    if (filterName == "cq_mcc") {
      newSelection = this.handleHeaderCheckboxCommon(
        item,
        filterName,
        "selectedMccCode"
      );
    }
    if (filterName == "cq_trnsctn_currency") {
      newSelection = this.handleHeaderCheckboxCommon(
        item,
        filterName,
        "selectedTransactionCurr"
      );
    }
    if (filterName == "cq_sttlmnt_crrncy") {
      newSelection = this.handleHeaderCheckboxCommon(
        item,
        filterName,
        "selectedSettlementCurr"
      );
    }

    if (filterName === "cq_ex_corp_region") {
      if (item.selected) {
        item.items.forEach((user) => {
          selectedCorpRegionCode.push(Object.assign({}, user));
        });
      } else {
        each(item.items, function (user) {
          let index = selectedCorpRegionCode.findIndex(
            (selectedUser) =>
              selectedUser.id == user.id && selectedUser.groupId == user.groupId
          );
          if (index != -1) selectedCorpRegionCode.splice(index, 1);
        });
      }

      newSelection = selectedCorpRegionCode.map((item) => {
        return `${item.groupId} - ${item.value}`;
      });
      corp = selectedCorpRegionCode.map((item) => {
        return item.groupId;
      });
      corp = corp.filter((x, i, a) => a.indexOf(x) == i);
      region = selectedCorpRegionCode.map((item) => {
        return item.value;
      });
      corpRegion = selectedCorpRegionCode.map((item) => {
        return { corp: item.groupId, region: item.value };
      });
      this.setState({
        corp: corp,
        region: region,
        corpRegion: corpRegion,
      });
    }

    newValues = Object.assign({}, this.state.currentValues, {
      [filterName]: { v1: newSelection },
    });

    this.setState({
      currentValues: newValues,
      selectedCorpRegionCode: selectedCorpRegionCode,
    });
  }

  handleHeaderCheckboxCommon(item, filterName, filterState) {
    let elementState = this.state[filterState] ? this.state[filterState] : [];
    let filterCodeFilters = this.state.sortedFilterList.find(
      (sortedFilter) => sortedFilter.elementId == filterName
    );

    filterCodeFilters &&
      filterCodeFilters.filterValues.map((filterValue) => {
        filterValue.items.map((filterItem) => {
          if (filterItem.selected) {
            let filterIndex = elementState.findIndex(
              (selectedCodeItem) =>
                selectedCodeItem.id == filterItem.id &&
                selectedCodeItem.groupId == filterItem.groupId
            );
            if (
              filterIndex == -1 &&
              this.state.currentValues &&
              this.state.currentValues[filterName] &&
              this.state.currentValues[filterName].v1 &&
              this.state.currentValues[filterName].v1.findIndex(
                (val) => val == filterItem.id
              ) != -1
            ) {
              elementState = elementState.concat(filterItem);
            }
          }
        });
      });
    elementState = Array.from(new Set(elementState));
    if (item.selected) {
      item.items.forEach((user) => {
        elementState.push(Object.assign({}, user));
      });
    } else {
      each(item.items, function (user) {
        let index = elementState.findIndex(
          (selectedUser) =>
            selectedUser.id == user.id && selectedUser.groupId == user.groupId
        );
        if (index != -1) elementState.splice(index, 1);
      });
    }

    this.setState({
      [filterState]: elementState,
    });

    return elementState.map((item) => {
      return item.value;
    });
  }

  toggleCollapse(item) {
    item.isExpanded = !item.isExpanded;
    this.setState({
      sortedFilterList: [...this.state.sortedFilterList],
    });
  }

  toggleExclusionCollapse(item) {
    item.isExpanded = !item.isExpanded;
    this.setState({
      sortedExclusionFilterList: [...this.state.sortedExclusionFilterList],
    });
  }

  toggleSearchDropDown(key) {
    const sortedFilterList = this.state.sortedFilterList.map((element) => {
      if (element.elementId === key) {
        this.setState({
          key: key,
          visibility: !this.state.visibility,
        });
        return Object.assign({}, element, {
          visibility: !this.state.visibility,
        });
      } else {
        this.setState({
          key: key,
          visibility: false,
        });
        return Object.assign({}, element, {
          visibility: false,
        });
      }
    });
    this.setState({
      sortedFilterList: sortedFilterList,
    });
  }

  toggleExclusionSearchDropDown(key) {
    const sortedExclusionFilterList = this.state.sortedExclusionFilterList.map(
      (element) => {
        if (element.elementId === key) {
          this.setState({
            key: key,
            visibility: !this.state.visibility,
          });
          return Object.assign({}, element, {
            visibility: !this.state.visibility,
          });
        } else {
          this.setState({
            key: key,
            visibility: false,
          });
          return Object.assign({}, element, {
            visibility: false,
          });
        }
      }
    );
    this.setState({
      sortedExclusionFilterList: sortedExclusionFilterList,
    });
  }

  handleOutsideClick(filterId) {
    const sortedFilterList =
      this.state.sortedFilterList &&
      this.state.sortedFilterList.map((element) => {
        if (filterId == element.elementId) {
          return Object.assign({}, element, {
            visibility: false,
          });
        } else {
          return Object.assign({}, element, {});
        }
      });

    this.setState({}, () => {
      this.setState({
        sortedFilterList: sortedFilterList,
        [filterId]: "",
      });
    });
  }

  handleExclusionOutsideClick(filterId) {
    const sortedExclusionFilterList =
      this.state.sortedExclusionFilterList &&
      this.state.sortedExclusionFilterList.map((element) => {
        if (filterId == element.elementId) {
          return Object.assign({}, element, {
            visibility: false,
          });
        } else {
          return Object.assign({}, element, {});
        }
      });

    this.setState({}, () => {
      this.setState({
        sortedExclusionFilterList: sortedExclusionFilterList,
        [filterId]: "",
      });
    });
  }
  updateMerchantList(filters) {
    // update newValues
    let merchant_hierarchy = { v1: filters };
    let newValues = Object.assign({}, this.state.currentValues, {
      merchant_hierarchy,
    });
    this.setState({
      currentValues: newValues,
      merchant_hierarchy,
      merchant_hierarchy_reset: false,
    });
  }
  displaySingleListSelector(buttonText, removeDivClass) {
    return (
      <OutsideClickHandler onClickOutside={this.handleClickOutside}>
        <div
          className={
            removeDivClass
              ? "single-list-selector-margin"
              : "center-align-list-selector"
          }
        >
          {this.state.availableFilters.length > 0 && (
            <DashedButton //defect id 48 => for Add another Filter' option disable after all filters in drop down getting added
              extraClass="dashed-button-width"
              action={() => {
                this.openSingleListSelector();
              }}
              style={removeDivClass ? { width: "192%" } : { width: "29%" }}
            >
              {buttonText}
            </DashedButton>
          )}
          {this.state.isSingleListSelectorOpen && (
            <SingleListSelector
              id={`${this.props.title}_DualListSelector`}
              onRef={(ref) => (this.child = ref)}
              availableColumns={this.state.availableFilters}
              activeColumns={this.state.sortedFilterList}
              isDialog
              translations={this.props.translations}
              updateColumnsInfo={this.props.updateColumnsInfo}
            />
          )}
        </div>
      </OutsideClickHandler>
    );
  }

  displayExclusionListSelector(buttonText, removeDivClass) {
    return (
      <OutsideClickHandler onClickOutside={this.handleExclusionClickOutside}>
        <div
          className={
            removeDivClass
              ? "single-list-selector-margin"
              : "center-align-list-selector"
          }
        >
          {this.props.availableExclusionFilters.length > 0 && (
            <DashedButton
              extraClass="dashed-button-width"
              action={() => {
                this.openExclusionList();
              }}
              style={removeDivClass ? { width: "230%" } : { width: "29%" }}
            >
              {buttonText}
            </DashedButton>
          )}
          {this.state.isExclusionListSelectorOpen && (
            <SingleListSelector
              id={`${this.props.title}_ExclusionListSelector`}
              onRef={(ref) => (this.child = ref)}
              availableColumns={this.state.availableExclusionFilters}
              activeColumns={this.state.sortedExclusionFilterList}
              extraClass=" "
              isDialog
              translations={this.props.translations}
              updateColumnsInfo={this.props.updateExclusionColumnsInfo}
            />
          )}
        </div>
      </OutsideClickHandler>
    );
  }

  cancelResponseBanner = () => {
    document.getElementById("Received Disputes_filterPane_btn_cancel") &&
      document.getElementById("Received Disputes_filterPane_btn_cancel").blur();
    this.setState({
      isCancelWarning: true,
    });
  };

  showWarningBanner() {
    return (
      <div>
        {this.state.isCancelWarning && (
          <ImagePortal>
            <ResponseBanner
              titleStyle={{ color: "light-green" }}
              description="You will lose all progress you have made."
              descriptionStyle={{ color: "grey" }}
              valueStyle={{ color: "black" }}
              title="Are you sure you want to cancel?"
              type="warning"
              onClose={this.closeBanner}
              cancelButtonText="DO NOT CANCEL"
              secondaryButtonAction={this.closeBanner}
              primaryButtonText="YES, PLEASE CANCEL"
              primaryButtonAction={this.closePanel}
            />
          </ImagePortal>
        )}
      </div>
    );
  }

  closeBanner() {
    this.setState({
      isCancelWarning: false,
    });
  }

  closePanel() {
    if (this.state.isSecSortListSelectorOpen) {
      this.removeSecondarySort();
    }
    if (this.state.exclusionVisibleCount > 0) {
      this.removeAllExclusions();
    }
    window.location.reload();
    this.clearFilters();
    this.props.closeFilterPane();
    this.setState({
      isCancelWarning: false,
    });
  }

  render() {
    const wrapperClass = classnames("custom-queue-filter-pane", {
      [this.props.extraClass]: this.props.extraClass,
      hidden: !this.props.isVisible,
      show: this.props.isVisible,
      push: this.props.pushFilterPane,
    });

    const filterPaneContentClass = classnames(
      "custom-queue-filter-pane__content",
      {
        more: this.state.showMoreFilters,
        base: !this.state.showMoreFilters,
      }
    );

    const moreLessText = this.state.showMoreFilters
      ? this.props.translations.less
      : this.props.translations.more;

    const moreLessExclusionText = this.state.showMoreExclusionFilters
      ? this.props.translations.less
      : this.props.translations.more;

    const { reportName, translations } = this.props;
    const globalFilter = this.state.merchant_hierarchy
      ? this.state.merchant_hierarchy.v1
      : undefined;
    let maxSortingRows = 3;
    let sortingMaxCount = maxSortingRows;
    return (
      <div id="custom-queue-filter-pane" className={wrapperClass}>
        {this.showWarningBanner()}
        <div className={filterPaneContentClass}>
          <div className="section-label">
            <p>Create Queue</p>
          </div>
          <div className="filter-input-container">
            {this.displayFilterList}
            {this.state.visibleCount > 0 &&
              this.props.showDynamicFilter &&
              this.displaySingleListSelector("+ Add Another Filter", true)}
          </div>

          {this.state.visibleCount > 6 ? (
            <div className="toggle-breakline">
              <PrimaryButton
                action={this.toggleFilters}
                extraClass="btn-breakline"
                iconDirection="right"
                icon={this.state.showMoreFilters ? TriangleUp : TriangleDown}
                id={`${reportName}_btn_${moreLessText}`}
              >
                {moreLessText}
              </PrimaryButton>
            </div>
          ) : (
            ""
          )}

          <div className="hr-border"></div>
          <div className="section-label">
            <p>Sorting</p>
          </div>
          <CustomQueueSorting
            filterList={this.props.filterList}
            sortFilterList={this.props.sortFilterList}
            visibleCount={this.state.visibleCount}
            availableSortFilterList={this.props.availableSortFilterList}
            showDynamicFilter={this.props.showDynamicFilter}
            updateValues={this.props.updateValues}
            isUpdate={this.props.isUpdate}
            availableFilters={this.props.availableFilters}
            translations={this.props.translations}
            displaySortFilterList={this.displaySortFilterList}
            sortingMaxCount={sortingMaxCount}
            activeSortFilters={this.props.activeSortFilters}
            filterValuesState={this.state.filterValuesState}
            filterValuesSortState={this.state.filterValuesSortState}
            updateCustomQueueSortingVal={this.updateCustomQueueSortingVal}
          />
          <div className="hr-border"></div>
          <div className="section-label">
            <p>
              Exclusions
              <InformationBubble
                info
                tooltipContent={
                  "Exclusions are useful for limiting the data shown in the queue"
                }
              />
              <div
                style={{
                  display: "inline-flex",
                  position: "absolute",
                  right: "25px",
                }}
              >
                <Button
                  action={this.removeAllExclusions}
                  extraClass="clear-exc-button"
                  id={`exc_clear_btn`}
                  disabled={
                    this.state.exclusionVisibleCount === 0 ? true : false
                  }
                  
                >
                  <strong>Clear All Exclusions</strong>
                </Button>
              </div>
            </p>
          </div>
          {this.state.exclusionVisibleCount === 0 && (
            <div style={{ padding: "15px" }}>
              <div className="center-align">
                <span>
                  Exclusions are useful for limiting the data shown in the queue
                </span>
              </div>
              {this.displayExclusionListSelector("+ Add Exclusion", false)}
            </div>
          )}
          <div className="filter-input-container">
            {this.displayExclusionFilterList(
              this.state.sortedExclusionFilterList
            )}
            {this.state.exclusionVisibleCount > 0 &&
              this.props.showDynamicFilter &&
              this.displayExclusionListSelector("+ Add Exclusion", true)}
          </div>
        </div>

        {this.state.exclusionVisibleCount > 6 ? (
          <div className="toggle-breakline">
            <PrimaryButton
              action={this.toggleExclusionFilters}
              extraClass="btn-breakline"
              iconDirection="right"
              icon={
                this.state.showMoreExclusionFilters ? TriangleUp : TriangleDown
              }
              id={`${reportName}_btn_${moreLessExclusionText}`}
            >
              {moreLessExclusionText}
            </PrimaryButton>
          </div>
        ) : (
          ""
        )}

        <div className="custom-queue-filter-pane__footer">
          <Button
            action={this.clearFilters}
            extraClass="clear-filters"
            category="link-inline"
            id={`${reportName}_btn_clear`}
          >
            <strong> {translations.clearFilterPane}</strong>
          </Button>
          <div className="custom-queue-filter-pane__footer-right">
            <Button
              action={this.cancelResponseBanner}
              extraClass="custom-queue-filter-pane__close-button"
              id={`${reportName}_btn_cancel`}
              style={this.props.cancelButtonStyle}
            >
              <strong>{translations.cancel}</strong>
            </Button>
            <PrimaryButton
              action={this.applyFilters}
              extraClass="custom-queue-filter-pane__apply-button"
              id={`${reportName}_btn_apply`}
              style={this.props.primaryButtonStyle}
              disabled={this.state.createUpdateButtonDisabled}
            >
              <strong> {translations.createQueueFilterPane}</strong>
            </PrimaryButton>
          </div>
        </div>
      </div>
    );
  }
}

CustomQueueFilterPane.propTypes = {
  applyFilters: PropTypes.func.isRequired,
  closeFilterPane: PropTypes.func.isRequired,
  currentValues: PropTypes.array,
  dateFormat: PropTypes.string.isRequired,
  extraClass: PropTypes.string,
  filterList: PropTypes.array.isRequired,
  isVisible: PropTypes.bool,
  pushFilterPane: PropTypes.bool,
  reportName: PropTypes.string,
  reportKey: PropTypes.string,
  translations: PropTypes.object,
  language: PropTypes.string,
  setAlertPrefs: PropTypes.func,
  deleteAlertPrefsByAlertkey: PropTypes.func,
  callOnBoardContainer: PropTypes.bool,
  resetScrollPos: PropTypes.func.isRequired,
  showDynamicFilter: PropTypes.bool,
  availableFilters: PropTypes.array,
  updateColumnsInfo: PropTypes.func,
  userPermission: PropTypes.object,
  isUpdate: PropTypes.bool,
  updateValues: PropTypes.array,
};

CustomQueueFilterPane.defaultProps = {
  userPermission: {},
  currentValues: [],
  setAlertPrefs: () => {},
  deleteAlertPrefsByAlertkey: () => {},
  extraClass: "",
  filterList: [],
  isVisible: false,
  pushFilterPane: false,
  reportName: "",
  reportKey: "",
  translations: {
    apply: "Apply",
    createQueueFilterPane: "Create",
    cancel: "Cancel",
    clear: "Clear",
    less: "Less",
    more: "More",
  },
  isUpdate: false,
  updateValues: [],
  callOnBoardContainer: true,
  showDynamicFilter: false,
  availableFilters: [],
  updateColumnsInfo: () => {},
  isExpanded: false,
  selectedCard: () => {},
  visibleFiltersCount: 6,
};

const mapStateToProps = (state) => ({
  dataColumns: state.dataColumns?.columns,
  isSearchActive: state.appSearch.isSearchActive,
  user: state.auth.user,
  filters: state.searchFilter.filters,
});

export default connect(mapStateToProps, null)(CustomQueueFilterPane);